module.exports = __webpack_public_path__ + "static/media/upload.6c17540f.svg";